import { OpenFile, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { t } from 'i18next';
import { useEffect, useRef } from 'react';

import { SlidingPanel } from 'core/components';
import { TextEllipsis } from 'core/elements';

import { contentWrapperStyle } from './style';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  fileName: string;
  fileUrl: string;
  subtitle?: string;
}

export const PreviewPdf = ({ isOpen, onClose, fileName, fileUrl, subtitle }: IProps) => {
  const fileNameRef = useRef(fileName);

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    toolbarPlugin: {
      getFilePlugin: {
        fileNameGenerator: (file: OpenFile) =>
          fileNameRef.current || file.name.substring(file.name.lastIndexOf('/') + 1),
      },
    },
  });

  useEffect(() => {
    fileNameRef.current = fileName;
  }, [fileName]);

  const title = (
    <TextEllipsis
      content={fileName || t('labelPreviewPdf')}
      style={{ fontSize: '24px' }}
      lineHeight={32}
    />
  );

  return (
    <SlidingPanel
      isOpen={isOpen}
      onClosePanel={onClose}
      title={title}
      subtitle={subtitle}
      contentStyle={contentWrapperStyle}
      autoWidth
    >
      <Viewer fileUrl={fileUrl} plugins={[defaultLayoutPluginInstance]} />
    </SlidingPanel>
  );
};
